export async function uploadTempImage(file: File) {
  const formData = new FormData()
  formData.append('file', file)
  return http.post<{ path: string }>('/v1/media/upload_temp_image', formData)
}

export async function fetchMediaLib(last_id: number) {
  return http.get<MediaLib>('/v1/media/library', { last_id })
}
